import { createRouter, createWebHashHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

// 错误处理包装器
const handleImportError = (name, err) => {
  console.error(`加载路由组件失败: ${name}`, err)
  ElMessage.error('页面加载失败，请刷新重试')
  throw err
}

const routes = [
  {
    path: '/',
    redirect: '/app',
  },
  {
    path: '/app',
    component: () => import('../modules/task/views/task/components/common/app-layout.vue').catch(err => handleImportError('app-layout', err)),
    children: [
      {
        path: '',
        redirect: '/app/m/sales',
      },
      {
        path: 'my-flow',
        name: 'app-my-flow',
        component: () => import('../modules/task/views/task/components/task-flow/task-flow-home.vue').catch(err => handleImportError('app-my-flow', err)),
        meta: {
          title: '我的流程',
          keepAlive: true,
        },
      },
      {
        path: 'm/sales',
        name: 'app-sales',
        component: () => import('../modules/sales/sales-univer-page.vue').catch(err => handleImportError('app-sales', err)),
        meta: {
          title: '销售',
          keepAlive: true,
        },
      },
      {
        path: 'm/:menuKey',
        name: 'app-module',
        component: () => import('../modules/task/views/task/components/common/coming-soon-page.vue').catch(err => handleImportError('app-module', err)),
        meta: {
          title: '敬请期待',
          keepAlive: true,
        },
      },
      {
        path: 'template',
        name: 'app-taskflowtemplate',
        component: () => import('../modules/task/views/task/components/task-flow-template/task-flow-template-home.vue').catch(err => handleImportError('app-taskflowtemplate', err)),
        meta: {
          title: '任务流模板',
          keepAlive: true,
        },
      },
      {
        path: 'work-flow',
        name: 'app-work-flow',
        component: () => import('../modules/task/views/task/components/task-flow/work-flow/work-flow.vue').catch(err => handleImportError('app-work-flow', err)),
        meta: {
          title: '工作流',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/task/flow',
    redirect: '/app/m/sales',
  },
  {
    path: '/app-home',
    redirect: '/app/m/sales',
  },
  {
    path: '/task/taskflowlist',
    redirect: '/app/m/sales',
  },
  {
    path: '/task/taskflowtemplate',
    redirect: '/app/template',
  },
  {
    path: '/task/work-flow-templates/:templateId/instances-table',
    redirect: '/app/m/sales',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../view/Login/index.vue').catch(err => handleImportError('login', err)),
    meta: {
      title: '登录',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/npl-login',
    name: 'npl-login',
    component: () => import('../view/Login/npl-login.vue').catch(err => handleImportError('npl-login', err)),
    meta: {
      title: 'NPL登录',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/landing',
    name: 'landing',
    component: () => import('../view/Login/page-landing.vue').catch(err => handleImportError('landing', err)),
    meta: {
      title: '登录中...',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/msg-landing',
    name: 'msg-landing',
    component: () => import('../view/Login/msg-landing.vue').catch(err => handleImportError('msg-landing', err)),
    meta: {
      title: '消息跳转',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/token-landing',
    name: 'token-landing',
    component: () => import('../view/Login/token-landing.vue').catch(err => handleImportError('token-landing', err)),
    meta: {
      title: 'Token登录',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/terms-privacy',
    name: 'terms-privacy',
    component: () => import('../view/Login/index.vue').catch(err => handleImportError('terms-privacy', err)),
    meta: {
      title: '用户协议',
      public: true,
      keepAlive: true,
    }
  },
  {
    path: '/dingTalk',
    name: 'dingTalk',
    component: () => import('../view/Login/ding-talk.vue').catch(err => handleImportError('dingTalk', err)),
    meta: {
      title: '钉钉登录',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/we-com',
    name: 'weCom',
    component: () => import('../view/Login/we-com.vue').catch(err => handleImportError('weCom', err)),
    meta: {
      title: '企业微信登录',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/we-com-test',
    name: 'weComTest',
    component: () => import('../view/Login/we-com-1.vue').catch(err => handleImportError('we-com-test', err)),
    meta: {
      title: '企业微信测试',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/we-com-2',
    name: 'weCom2',
    component: () => import('../view/Login/we-com-2.vue').catch(err => handleImportError('we-com-2', err)),
    meta: {
      title: '企业微信2',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/lark',
    name: 'lark',
    component: () => import('../view/Login/lark.vue').catch(err => handleImportError('lark', err)),
    meta: {
      title: '飞书登录',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/file-preview',
    name: 'file-preview',
    component: () => import('../components/common/vue-office/vue-office.vue').catch(err => handleImportError('file-preview', err)),
    meta: {
      title: '文件预览',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/file-preview-plus',
    name: 'file-preview-plus',
    component: () => import('../components/common/preview-attachments/preview-attachment.vue').catch(err => handleImportError('file-preview-plus', err)),
    meta: {
      title: '附件预览',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/media-preview',
    name: 'media-preview',
    component: () => import('../components/common/media-preview/media-preview.vue').catch(err => handleImportError('media-preview', err)),
    meta: {
      title: '媒体预览',
      public: true,
      keepAlive: false,
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../view/Login/index.vue').catch(err => handleImportError('not-found', err)),
    meta: {
      title: '页面未找到',
      public: true,
      keepAlive: false,
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }

    if (savedPosition) {
      return savedPosition
    }

    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - ITA Flow` : 'ITA Flow'

  if (to.meta.public) {
    next()
    return
  }

  next()
})

router.onError((error) => {
  console.error('路由错误:', error)
  ElMessage.error('页面加载失败，请刷新重试')
})

export default router
